import styles from './TableOfContents.module.css';

interface TocItem {
  id: string;
  label: string;
}

interface TableOfContentsProps {
  items: TocItem[];
  activeId?: string;
}

export function TableOfContents({ items, activeId }: TableOfContentsProps) {
  return (
    <nav className={styles.toc} aria-label="Table of contents">
      <div className={styles.title}>On this page</div>
      <ul className={styles.list}>
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={[styles.link, activeId === item.id ? styles.activeLink : '']
                .filter(Boolean)
                .join(' ')}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
